import {
  fetchUpdateUserReplyTemplate,
  type TUpdateUserReplyTemplateResponse,
  type TUpdateUserReplyTemplateRequest,
} from '../../repositories/chats/v1/update-user-reply-template';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

const DEFAULT_ERROR_MESSAGE = 'Ошибка обновления шаблона ответа';

export async function updateUserReplyTemplatePublic(
  context: IApplicationContext,
  parameters: TUpdateUserReplyTemplateRequest,
) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TUpdateUserReplyTemplateResponse> =
      await fetchUpdateUserReplyTemplate({
        httpApi,
        parameters,
      });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.ReplyTemplates,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return response;
  } catch (e) {
    const exception = getGenericLikeError({
      error: e,
      domain: EExceptionDomain.ReplyTemplates,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/update-user-reply-template/',
      parameters: JSON.stringify(parameters),
    });

    throw exception;
  }
}
